import { Box } from '@mui/material';

import { CollectionStatus } from 'src/types';
import { useLocales } from 'src/locales';

type Props = {
  status?: CollectionStatus | null;
};

/**
 * The backend stores the literal string `none` for a client nobody has touched — 1650 of them
 * on production — and `null` for one whose row predates the column. Both mean the same thing
 * here, and neither may render as an empty cell: a blank looks like a loading failure on a
 * page where every other cell is populated.
 */
const STATUS_STYLE: Record<CollectionStatus, { bg: string; text: string }> = {
  none: { bg: 'grey.200', text: 'text.secondary' },
  da_contattare: { bg: 'warning.lighter', text: 'warning.darker' },
  contattato: { bg: 'info.lighter', text: 'info.darker' },
  promessa_pagamento: { bg: 'success.lighter', text: 'success.darker' },
  in_contestazione: { bg: 'error.lighter', text: 'error.darker' },
  escalato: { bg: 'error.light', text: 'common.white' },
};

export default function CollectionStatusChip({ status }: Props) {
  const { t } = useLocales('operativaDashboard');
  const resolved: CollectionStatus = status ?? 'none';
  const style = STATUS_STYLE[resolved] ?? STATUS_STYLE.none;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        typography: 'caption',
        px: 1.25,
        py: 0.25,
        borderRadius: '99px',
        fontWeight: 'fontWeightMedium',
        whiteSpace: 'nowrap',
        backgroundColor: style.bg,
        color: style.text,
      }}
    >
      {t(`stato_${resolved}`)}
    </Box>
  );
}
